import { Container } from "../shared/Container"
import { NavItem } from "../shared/NavItem"
import { navItems } from "./Navbar"
import logo from "/assets/icon.jpg"

export const Footer = () => {
  return (
    <footer className="bg-box-bg relative rounded-t-3xl pt-28">
      <Container className="pb-8">
        <div className="flex flex-col items-center justify-between md:flex-row">
          <div className="mb-4 flex items-center gap-3 md:mb-0">
            <img src={logo} className="h-7 w-7" alt="TurboDVM Logo" />
            <span className="text-heading-1 text-lg font-semibold">TurboDVM</span>
          </div>

          <ul className="text-heading-1 flex gap-6">
            {navItems.map((item, key) => (
              <NavItem key={key} href={item.href} text={item.text} />
            ))}
          </ul>
        </div>
      </Container>
    </footer>
  )
}
